import React, { useMemo, useState } from 'react'
import clsx from 'clsx'
import { createStyles, makeStyles, Typography } from '@material-ui/core'
import { SwipeableDrawer, useMediaQuery, useTheme } from '@mui/material'
import { useFilterDrawerStyles } from '../Filters/FilterDrawer.styles'
import BraSizeGuide from './BraSizeGuide'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) =>
  createStyles({
    guideLink: {
      textDecoration: 'underline',
      cursor: 'pointer',
      fontSize: 14,
      marginLeft: theme.spacing(0.5),
      '&:hover': {
        opacity: 0.7,
      },
      [theme.breakpoints.down('md')]: {
        fontSize: 11,
      },
    },
  })
)
const drawerBleeding = 56

const BraSizeGuideDrawer = () => {
  const { t } = useTranslation('texts')
  const classes = useStyles()
  const drawerClasses = useFilterDrawerStyles()
  const theme = useTheme()

  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const handleOpen = () => {
    setIsDrawerOpen(true)
  }
  const handleClose = () => {
    setIsDrawerOpen(false)
  }
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const anchor: 'right' | 'bottom' = useMemo(() => {
    return isMobile ? 'bottom' : 'right'
  }, [isMobile])

  return (
    <>
      <Typography
        component="span"
        className={classes.guideLink}
        onClick={handleOpen}
      >
        {t('size_guide_page.span_title')}
      </Typography>
      <SwipeableDrawer
        id="cart-menu"
        className={clsx(drawerClasses.drawer)}
        onOpen={handleOpen}
        open={isDrawerOpen}
        onClose={handleClose}
        anchor={anchor}
        swipeAreaWidth={drawerBleeding}
      >
        <BraSizeGuide />
      </SwipeableDrawer>
    </>
  )
}

export default BraSizeGuideDrawer
